import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styles from './SelectStatus.module.scss';
import classNames from 'classnames/bind';
import { Circle2Icon, CircleIcon } from '~/assets/icons';
import BaseSelect from '~/components/common/base-select/BaseSelect';
import { STATUSES } from '~/utils/constants/jobs';
import { SelectOption, SelectOptions } from '~/utils/types/common';
import { useEffect, useMemo, useState } from 'react';

export type SelectStatusProps = {
  name?: string;
  label?: string;
  options?: SelectOptions;
  value?: string;
};

const cx = classNames.bind(styles);

const SelectStatus = (props: SelectStatusProps) => {
  //#region Destructuring Props
  const { ...restProps } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation('admin/component');
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  const label = props.label || t('selectStatus.label');
  const defaultOptions = useMemo(() => {
    return STATUSES.sort().map((value) => {
      return {
        id: value,
        name: t(`selectStatus.statuses.${value}`),
      };
    });
  }, [t]);
  const options: SelectOptions = props.options || defaultOptions;
  const [value, setValue] = useState<string>();

  //#endregion Declare State

  //#region Implement Hook
  useEffect(() => {
    if (props.value) setValue(props.value);
  }, [props.value]);
  //#endregion Implement Hook

  //#region Handle Function
  const renderStatusComponent = (item: SelectOption) => {
    return (
      <Box className={cx('status', item.id)}>
        <Circle2Icon className='w-[17px] h-[17px] option-icon-selected' />
        <CircleIcon className='w-[17px] option-icon' />
        {item.name}
      </Box>
    );
  };
  //#endregion Handle Function

  const renderSelectedStatusComponent = (item: SelectOption) => {
    return (
      <Box className={cx('status', item.id, 'selected-status')}>
        <Circle2Icon className='w-[13px] h-[13px] option-icon-selected-input' />
        {item.name}
      </Box>
    );
  };

  return (
    <>
      <BaseSelect
        {...restProps}
        onChange={(e) => setValue(e.target.value)}
        value={value}
        menuClassName={cx('select-status-menu')}
        label={label}
        options={options}
        renderSelected={(item: SelectOption) => renderSelectedStatusComponent(item)}
        renderOptionItem={(item: SelectOption) => renderStatusComponent(item)}
      />
    </>
  );
};

export default SelectStatus;
